import { render } from "./PoliticaCookies.vue?vue&type=template&id=2182fbcb&scoped=true"
import script from "./PoliticaCookies.vue?vue&type=script&lang=js"
export * from "./PoliticaCookies.vue?vue&type=script&lang=js"

import "./PoliticaCookies.vue?vue&type=style&index=0&id=2182fbcb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2182fbcb"]])

export default __exports__